import { all } from 'redux-saga/effects'
import createSagaMiddleware from 'redux-saga'

import authenticationSaga from '../../modules/authentication/sagas'
import configurationSaga from '../../modules/configuration/sagas'
import locationSaga from '../../modules/location/sagas'
import userAccountSaga from '../../modules/user/sagas'
import categoriesSaga from '../../modules/products/sagas'
import basketSaga from '../../modules/basket/sagas'
import walletSaga from '../../modules/wallet/sagas'
import orderSaga from '../../modules/orders/sagas'
import tokenRefreshSaga from 'modules/tokenRefresh/sagas'
import helpDetailsSaga from 'modules/help/sagas'
import contactUs from 'modules/contactUs/sagas'
import helpCenter from 'modules/helpCenter/sagas'
import sagaMonitor from './sagaMonitor'
import subscriptionsSaga from 'modules/subscription/sagas'
import contentSaga from 'modules/content/sagas'
import cateringSaga from '../../modules/catering/saga'

const effectMiddleware = next => effect => {
    if (effect.type === 'PUT') {
        const { action } = effect.payload
        const status = action.payload && action.payload.status

        // Customize the payload incase of 401 & 403
        if ([401, 403].includes(status)) {
            const effect401 = {
                ...effect,
                payload: {
                    ...effect.payload,
                    action: {
                        ...action,
                        meta: { errorStatus: status },
                    },
                },
            }

            return next(effect401)
        }
        return next(effect)
    }
    return next(effect)
}

// export const sagaMiddleware = createSagaMiddleware()

export const sagaMiddleware = createSagaMiddleware({
    sagaMonitor,
    effectMiddlewares: [effectMiddleware],
})

export default function* rootSaga() {
    /**
     * Invoke saga watch generators here.
     */
    yield all([
        authenticationSaga(),
        configurationSaga(),
        helpDetailsSaga(),
        contactUs(),
        locationSaga(),
        userAccountSaga(),
        categoriesSaga(),
        basketSaga(),
        walletSaga(),
        orderSaga(),
        tokenRefreshSaga(),
        helpCenter(),
        subscriptionsSaga(),
        contentSaga(),
        cateringSaga(),
    ])
}
